export default "__VITE_ASSET__Drb3M8Bz__"